/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class NotFoundError extends errors.TruvityError {
    constructor(body: Truvity.NotFoundProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'NotFoundError',
            statusCode: 404,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
